module.exports = __webpack_public_path__ + "img/movil.f9ad5bc6.png";